import getRelayEnvironment from '../../../relayClientEnvironment';
import { importModuleAndRenderNotification } from '../helpers/renderHelpers';

async function importTradeRewardsLevelUpModalWrapper() {
    const mod = await import(
        /* webpackChunkName: "TradeRewardsLevelUpModalRendererWrapperChunk" */
        '../../../TradeRewardsLevelUpModal/TradeRewardsLevelUpModalRendererWrapper'
    );
    return mod.default;
}

export const tradeRewardsLevelUpModalAction = ({ customActionType }) => dispatch => {
    importModuleAndRenderNotification({
        importFunc: importTradeRewardsLevelUpModalWrapper,
        containerClassName: 'tradeGeneralOnboardingContainer',
        props: {
            environment: getRelayEnvironment(),
        },
    });

    return dispatch({ type: customActionType.actionType });
};
